import { FC, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Base64 } from 'js-base64';
import jsSHA from 'jssha';

import { reducerLoginStatus } from '../../redux/reducer/user/reducers/reducerUser';
import { actionCheckTokenValidity } from '../../redux/action/user/actionUser';
import { AppDispatch } from '../../redux/reducer/store';

import {ReactComponent as HidePassword } from '../../assets/icons/hidePassword.svg';
import {ReactComponent as ShowPassword } from '../../assets/icons/showPassword.svg';
import ArrowRight from '../../assets/icons/arrowRight.svg';
import { ReactComponent as Profile } from '../../assets/icons/Profile.svg';
import { ReactComponent as Lock } from '../../assets/icons/Lock.svg';

import styles from './login.module.scss';
import { IUserOptions } from '../../types/interfaces';
import ThemeSwitcher from '../../components/themeSwitcher/themeSwitcher';

const Login: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  
  const {data, loginStatus} = useSelector((state: IUserOptions) => state.user.user);
  const {claims} = useSelector((state: IUserOptions) => state.user.user.data);
  
  const photoViewerInstance = document.querySelector('.photoviewer-modal');
  
  const [isVisiblePassword, setIsVisiblePassword] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [login, setLogin] = useState<string>('');
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlLogin = params.get('login');
    const urlPassword = params.get('password');
    
    if (urlPassword && urlLogin) {
      setLogin(urlLogin);
      setPassword(urlPassword);
      handleLogin(urlLogin, urlPassword);
    }
    
    if (photoViewerInstance) {
      photoViewerInstance.remove();
    }
    // eslint-disable-next-line
  }, []);
  
  useEffect(() => {
    if (photoViewerInstance) {
      photoViewerInstance.remove();
    }
  }, [photoViewerInstance]);
  
  useEffect(() => {
    if (loginStatus === 0) {
      setIsError(true);
    } else if (loginStatus === 200) {
      localStorage.setItem('token', 'Basic ' + data.token);
      localStorage.setItem('userData', JSON.stringify(data));
      navigate('/reports');
      setIsError(false);
    }
  }, [data, loginStatus, navigate]);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleLogin(login, password);
    }
  };
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, setState: (state: string) => void) => {
    setState(event.target.value);
    setIsError(false);
  };
  
  const handleLogin = (login: string, password: string) => {
    if (!login || !password) {
      return;
    }
    const shaObj = new jsSHA('SHA-1', 'TEXT', {encoding: 'UTF8'});
    shaObj.update(password);
    const hashedPassword = shaObj.getHash('B64');
    
    const token = Base64.encode(login + ':' + hashedPassword);
    
    dispatch(actionCheckTokenValidity(token)).then(() => {
      dispatch(reducerLoginStatus(null));
    });
  };
  
  if (localStorage.getItem('token')) {
    
    if (data.isCustomer) {
      if (data.settings.analytics) {
        return <Navigate to='/charts' />
      } else {
        return <Navigate to='/reports' />
      }
    }
    
    if (!claims || claims?.length < 1) {
      return <Navigate to='/page404' />
    }
    
    if (claims.includes('admin')) {
      return <Navigate to='/reports' />
    }
    
    if (claims.includes('reports:view')) {
      return <Navigate to='/reports' />
    } else if (claims.includes('reports:expired:view')) {
      return <Navigate to='/reports/expired' />
      
    } else if (claims.includes('orders:excel')) {
      return <Navigate to='/unloadings/excel' />
    } else if (claims.includes('orders:zip')) {
      return <Navigate to='/unloadings/zip' />
    } else if (claims.includes('orders:payrolls')) {
      return <Navigate to='/unloadings/tables' />
    } else if (claims.includes('orders:cron')) {
      return <Navigate to='/unloadings/cron' />
      
    } else if (claims.includes('tander:view')) {
      return <Navigate to='/tunder/shops' />
      
    } else if (claims.includes('easy-merch:view')) {
      return <Navigate to='/easymerch/outlets' />
      
    } else if (claims.includes('customers:list')) {
      return <Navigate to='/accessRights/customers' />
    } else if (claims.includes('role:claim:change')) {
      return <Navigate to='/accessRights/roles' />
      
    } else if (claims.includes('projects:list')) {
      return <Navigate to='/projects' />
      
    } else if (claims.includes('claim:employee:list')) {
      return <Navigate to='/accessRights/users' />
      
    } else if (claims.includes('pos:map:view')) {
      return <Navigate to='/map' />
    } else {
      return <Navigate to='/page404' />
    }
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.themeSwitcherContainer}>
        <ThemeSwitcher />
      </div>
      <div className={styles.block}>
        <h1 className={styles.title}>Merch Online</h1>
        <div className={styles.input__block}>
          <div className={styles.icon}>
            <Profile color='black' />
          </div>
          <input
            onKeyDown={handleKeyDown}
            onChange={event => handleInputChange(event, setLogin)}
            className={styles.input}
            placeholder='Логин'
            type='text'
            value={login}
          />
        </div>
        <div className={styles.input__block}>
          <div className={styles.icon}>
            <Lock color='black' />
          </div> <input
          onChange={event => handleInputChange(event, setPassword)}
          type={isVisiblePassword ? 'text' : 'password'}
          onKeyDown={handleKeyDown}
          className={styles.input}
          placeholder='Пароль'
          value={password}
        />
          <div className={styles.password__icon} onClick={() => setIsVisiblePassword(!isVisiblePassword)}>
            {isVisiblePassword ? <HidePassword color='black' /> : <ShowPassword color='black' />}
          </div>
        </div>
        {isError && (
          <span className={styles.error__message}>
						Введены неверный логин или пароль.
					</span>
        )}
        <div className={styles.login__btn} onClick={() => handleLogin(login, password)}>
          <span className={styles.login__text}>Войти</span> <img src={ArrowRight} className={styles.arrow__icon}
                                                                 alt='' />
        </div>
      </div>
    </div>
  );
};

export default Login;
